var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12V7H0V5.5H4.52083V7H3V12H1.5ZM1.5 4V0H3V4H1.5ZM4.75 4V2.5H6.25V0H7.75V2.5H9.25V4H4.75ZM6.25 12V5.5H7.75V12H6.25ZM11 12V9.5H9.47917V8H14V9.5H12.5V12H11ZM11 6.5V0H12.5V6.5H11Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetControlIcon);
export default __webpack_public_path__ + "static/media/setControlIcon.7a8207e7fb21229b644022691779dff8.svg";
export { ForwardRef as ReactComponent };